<template>
  <el-dialog title="移除区域" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :model="form" label-position="right" size="small" label-width="110px">
      <el-form-item label="" prop="childDetail">
        <div v-for="(item,index) in form.childDetail" :key="index" class="full-box">
          <el-cascader v-model="item.districtCode" :props="cascaderProps" collapse-tags :options="options.areaOptions" placeholder="请选择需要移除的区域" clearable></el-cascader>
          <!-- <div class="full-icon">
            <i class="el-icon-plus" @click="handleAddCustomer"></i>
            <i class="el-icon-minus" @click="handleDeleteCustomer(index)"></i>
          </div> -->
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CityCompanyAddrAreaApi from '@/api/sys/CityCompanyAddrArea'
function initFormBean() {
  const formBean = {
    childDetail: [{
      // technicianInfoId: '',
      districtCode: ''
    }]
  }
  return formBean
}
export default {
  data() {
    return {
      formVisible: false,
      form: initFormBean(),
      options: {
        areaOptions: [],
      },
      isLoading: false,
      cascaderProps: {
        label: 'areaName',
        value: 'areaCode',
        children: 'child',
        multiple: true
      },
      id: null,
      levelId: null
    }
  },
  methods: {
    // 获取地区
    changeIdentity() {
      CityCompanyAddrAreaApi.CityCompanyAddrAreaListForTree({ cityCompanyId: this.id, }).then(({
        data
      }) => {
        this.options.areaOptions = data ? this.formatCascaderData(data) : []
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    cascaderData(data) {
      return data.reduce((data, item) => (data.push(...item.districtCode.map(id => ({ ...item, districtCode: id[2] }))), data), [])
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.options.areaOptions = []
      this.form = initFormBean()
    },
    handleUpdate(row) {
      this.id = row.id
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.changeIdentity()
      })
    },
    doCreate() {
      this.isLoading = true
      // if(!arr.length) return this.$message.error('内容不能为空')
      let arr = this.cascaderData(this.form.childDetail)

      // console.log('this.form.childDetail: ',this.form.childDetail,arr);
      CityCompanyAddrAreaApi.transfer({ cityCompanyId: this.id, detail: arr })
        .then(() => {
          this.$message.success('操作成功')
          this.formVisible = false;
          this.$emit('created')
          this.isLoading = false
        }).catch(res => {
          this.isLoading = false
        })

    }
  }
}
</script>
<style lang="scss" scoped>
// .el-form-item--small.el-form-item {
//   width: 48%;
//   display: inline-block;
//   vertical-align: top;
// }
// .el-form-item--small.el-form-item.width100 {
//   width: 97%;
// }
::v-deep .el-select {
  width: 50%;
  margin-left: 5px;
}

::v-deep .el-cascader {
  width: 100%;
  // height: 32px;
  // line-height: 32px;

  // input {
  //   height: 32px;
  //   line-height: 32px;
  // }
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
</style>
